import React, { Component } from 'react';
import PropTypes from "prop-types";

import { connect } from 'react-redux';
import {
  fetchMobileAppsLinksList,
  clearDeleteMobileAppsLink,
  clearPatchMobileAppsLink,
  applyMobileAppsLinkDrag,
  clearMobileAppsLinkDrag,
  clearAddMobileAppsLink,
} from 'redux/links/actions';

import {
  DragDropContext,
  Droppable,
  Draggable,
} from "react-beautiful-dnd";
import { Loader } from 'semantic-ui-react';

import MobileAppLinkItem
  from 'components/dashboard/mobile-app-links/MobileAppLinkItem';
import MobileAppLinkItemMob
  from 'components/dashboard/mobile-app-links/MobileAppLinkItemMob';
import CommonMessage from 'components/common/CommonMessage';

import './MobileAppsLinksList.css';

class MobileAppsLinksList extends Component {
  static propTypes = {
    fetchMobileAppsLinksList: PropTypes.func.isRequired,
    clearDeleteMobileAppsLink: PropTypes.func.isRequired,
    clearPatchMobileAppsLink: PropTypes.func.isRequired,
    applyMobileAppsLinkDrag: PropTypes.func.isRequired,
    clearMobileAppsLinkDrag: PropTypes.func.isRequired,
    clearAddMobileAppsLink: PropTypes.func.isRequired,
    mobileAppsLinksList: PropTypes.arrayOf(PropTypes.shape),
    mobileAppsLinksListError: PropTypes.object,
    deleteMobileAppsLinkSuccess: PropTypes.object,
    pacthMobileAppsLinkSuccess: PropTypes.object,
    mobileAppsLinksDragSuccess: PropTypes.object,
    addMobileAppsLinkSuccess: PropTypes.object,
    device: PropTypes.string.isRequired,
  };

  static defaultProps = {
    mobileAppsLinksList: null,
    mobileAppsLinksListError: null,
    deleteMobileAppsLinkSuccess: null,
    pacthMobileAppsLinkSuccess: null,
    addMobileAppsLinkSuccess: null,
  };

  state = {
    items: null,
  };

  componentDidMount() {
    this.setState({ items: this.props.mobileAppsLinksList });
  }

  componentDidUpdate(prevProps) {
    // Set Current List
    if (prevProps.mobileAppsLinksList !== this.props.mobileAppsLinksList) {
      this.setState({ items: this.props.mobileAppsLinksList });
    }

    // Drag and Drop
    if (
      !prevProps.mobileAppsLinksDragSuccess &&
      prevProps.mobileAppsLinksDragSuccess !== this.props.mobileAppsLinksDragSuccess
    ) {
      this.props.fetchMobileAppsLinksList();
      this.props.clearMobileAppsLinkDrag();
    }

    // Add
    if (
      !prevProps.addMobileAppsLinkSuccess &&
      prevProps.addMobileAppsLinkSuccess !== this.props.addMobileAppsLinkSuccess
    ) {
      this.props.fetchMobileAppsLinksList();
      this.props.clearAddMobileAppsLink();
    }

    // Delete
    if (
      !prevProps.deleteMobileAppsLinkSuccess &&
      prevProps.deleteMobileAppsLinkSuccess !== this.props.deleteMobileAppsLinkSuccess
    ) {
      this.props.fetchMobileAppsLinksList();
      this.props.clearDeleteMobileAppsLink();
    }

    // Patch
    if (
      !prevProps.patchMobileAppsLinkSuccess &&
      prevProps.patchMobileAppsLinkSuccess !== this.props.patchMobileAppsLinkSuccess
    ) {
      this.props.fetchMobileAppsLinksList();
      setTimeout(() => {
        this.props.clearPatchMobileAppsLink();
      }, 500);
    }
  };

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  onDragEnd = result => {
    if (!result.destination) {
      return;
    }

    const items = this.reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({ items }, () => {
      const form = new FormData();
      this.state.items.map(item => item.id)
        .forEach(item => form.append('order', item));
      this.props.applyMobileAppsLinkDrag(form);
    });
  };

  renderLinksList = () => {
    const { items } = this.state;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {provided => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {items && items.map((item, index) => (
                <Draggable
                  key={`${item.id}`}
                  draggableId={`${item.id}`}
                  index={index}
                >
                  {provided => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      {this.props.device === 'desktop' ?
                        <MobileAppLinkItem
                          key={`mobile-app-link-item-key-${item.id}`}
                          item={item}
                          patchMobileAppsLinkSuccess={this.props.patchMobileAppsLinkSuccess}
                        />
                        :
                        <MobileAppLinkItemMob
                          key={`mobile-app-link-item-mob-key-${item.id}`}
                          item={item}
                          patchMobileAppsLinkSuccess={this.props.patchMobileAppsLinkSuccess}
                        />
                      }
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  render() {
    const {
      mobileAppsLinksList,
      mobileAppsLinksListError,
    } = this.props;

    return (
      <div className="mobile-apps-links-list__component">
        {/* Loader */}
        {!mobileAppsLinksList && !mobileAppsLinksListError &&
          <Loader active />
        }

        {mobileAppsLinksList && this.renderLinksList()}

        {/* Fetch Mobile Apps Links Error */}
        {mobileAppsLinksListError &&
          <CommonMessage
            error
            errors={mobileAppsLinksListError}
          />
        }
      </div>
    );
  }
};

const mapStateToProps = state => (
  {
    mobileAppsLinksList: state.linksReducer.mobileAppsLinksList,
    mobileAppsLinksListError: state.linksReducer.mobileAppsLinksListError,
    deleteMobileAppsLinkSuccess: state.linksReducer.deleteMobileAppsLinkSuccess,
    patchMobileAppsLinkSuccess: state.linksReducer.patchMobileAppsLinkSuccess,
    mobileAppsLinksDragSuccess: state.linksReducer.mobileAppsLinksDragSuccess,
    addMobileAppsLinkSuccess: state.linksReducer.addMobileAppsLinkSuccess,
    device: state.commonReducer.device,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMobileAppsLinksList,
    clearDeleteMobileAppsLink,
    clearPatchMobileAppsLink,
    applyMobileAppsLinkDrag,
    clearMobileAppsLinkDrag,
    clearAddMobileAppsLink,
  },
)(MobileAppsLinksList);
